import { useCallback } from 'react';

import { useDeletePalletMutation } from '../api/palletsApi';
import type { DeletePalletParams } from '../api/palletsApi';

export interface UseDeletePalletOptions {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
}

export const useDeletePallet = (options?: UseDeletePalletOptions) => {
  const [deletePallet, { isLoading, isSuccess, isError, error }] = useDeletePalletMutation();

  const handleDelete = useCallback(
    async (params: DeletePalletParams) => {
      try {
        await deletePallet(params).unwrap();
        options?.onSuccess?.();
      } catch (error) {
        options?.onError?.(error);
        throw error;
      }
    },
    [deletePallet, options]
  );

  return {
    deletePallet: handleDelete,
    isLoading,
    isSuccess,
    isError,
    error
  };
};
